export enum IHostDetailsPageTabs {
  Overview = 'overview',
  VirtualMachines = 'vms',
  Volumes = 'volumes',
  ResourceUtilization = 'resourceUtilization',
  AdvancedConfiguration = 'advancedConfiguration',
}
